import React from "react"
import Card       from "@react/shared/ui/Card"
import EmptyState from "@react/shared/ui/EmptyState"

const GRID = "1fr 1fr 1fr"
const fmt = m => (m && m.formatted) || "—"

const TiersSection = ({ tiers }) => (
  <Card className="rounded-lg">
    <div className="px-4 py-3 border-b border-slate-200">
      <h2 className="text-base font-semibold text-slate-900">
        {I18n.t("mbc_contracts.off_bpu_tiers.title", { defaultValue: "Tarification hors BPU" })}
      </h2>
      <p className="text-xs text-slate-500 mt-0.5">
        {tiers.length} {tiers.length === 1 ? "tranche" : "tranches"}
      </p>
    </div>

    {tiers.length === 0 ? (
      <EmptyState size="lg">
        {I18n.t("mbc_contracts.off_bpu_tiers.none", { defaultValue: "Aucune tranche hors BPU configurée" })}
      </EmptyState>
    ) : (
      <div>
        <div
          className = "grid items-center gap-x-3 px-4 py-3 border-b border-slate-200 bg-slate-50/50 uppercase tracking-wider text-[11px] font-medium text-slate-500"
          style     = {{ gridTemplateColumns: GRID }}
        >
          <div className="text-right">{I18n.t("mbc_contracts.off_bpu_tiers.min_purchase_price")}</div>
          <div className="text-right">{I18n.t("mbc_contracts.off_bpu_tiers.max_purchase_price")}</div>
          <div className="text-right">{I18n.t("mbc_contracts.off_bpu_tiers.coefficient")}</div>
        </div>
        {tiers.map(tier => (
          <div
            key       = {tier.id}
            className = "grid items-center gap-x-3 px-4 py-2.5 border-b border-slate-100 last:border-b-0"
            style     = {{ gridTemplateColumns: GRID }}
          >
            <div className="text-right text-sm text-slate-700 tabular-nums">{fmt(tier.min_purchase_price)}</div>
            <div className="text-right text-sm text-slate-700 tabular-nums">
              {tier.max_purchase_price ? fmt(tier.max_purchase_price) : "—"}
            </div>
            <div className="text-right text-sm text-slate-900 tabular-nums font-medium">
              ×{Number(tier.coefficient).toFixed(3).replace(/\.?0+$/, "")}
            </div>
          </div>
        ))}
      </div>
    )}
  </Card>
)

export default TiersSection
